<template>
  <div class="form-page">
    <!-- yes/no -->
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <div class="form-yes-no__wrap">
      <button class="form-button form-var"
        v-for="(value, index) in history[currentStep].field.values"
        :key="index"
        :class="{'success': history[currentStep].value === value.value}"
        :name="history[currentStep].name"
        @click="handleInput(value.value)">
        {{value.label}}
      </button>
    </div>
    <div class="radio-additional" v-if="history[currentStep].name === 'creditea_agreements' && +country === 2">
      <div @click="showAdditional = !showAdditional" class="radio-additional__title">T&C para las sociedades de información Crediticia<div class="radio-additional__arrow" :class="{opened : showAdditional}"></div></div>
      <transition name="fade">
        <div v-if="showAdditional" class="radio-additional__content">
          Por este conducto autorizo expresamente a IPF Digital México S.A. de C.V., para que por conducto de sus funcionarios facultados lleve a cabo investigaciones sobre mi comportamiento crediticio en las Sociedades de Información Crediticia que estime conveniente. Así mismo declaro que conozco la naturaleza y alcance de la información que se solicita, del uso que IPF Digital México S.A. de C.V. hará de la información y de que esta podrá realizar consultas periódicas de mi historial crediticio, consintiendo que esta autorización se encuentra vigente por un periodo de 3 años contados a partir de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación jurídica
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'

export default {
  name: 'Radio',
  components: { InfoIcon },
  data: function () {
    return {
      // carFieldsHardcore: ['plate_number', 'car_km', 'car_brand', 'car_model', 'car_year_registration', 'car_financing']
      showAdditional: false
    }
  },
  computed: mapState({
    history: state => state.history,
    currentStep: state => state.currentStep,
    config: state => state.config,
    provider: state => state.additionalParams.provider,
    country: state => state.additionalParams.country
  }),
  methods: {
    handleInput (val) {
      console.log('UPDATE_FIELD', val)
      this.$store.commit('UPDATE_FIELD', {isValid: true, value: val})

      const radioHandler = (val, fields) => {
        // fields = [{ name: 'fieldName', skipValue: 0, deleteOnYes: false, deleteOnNo: false }]
        if (val) {
          for (let i in fields) {
            const payload = {
              index: this.currentStep + 1 + +i,
              data: { name: fields[i].name, skip: false }
            }
            if (fields[i].deleteOnYes) payload.deleteStep = true
            this.$store.dispatch('insertOrUpdateField', payload)
          }
        } else {
          for (let i in fields) {
            const payload = {
              index: this.currentStep + 1 + +i,
              data: { name: fields[i].name, skip: true, value: fields[i].skipValue || 0, isValid: true }
            }
            if (fields[i].deleteOnNo) payload.deleteStep = true
            this.$store.dispatch('insertOrUpdateField', payload)
          }
        }
      }

      if (this.history[this.currentStep].name === 'has_other_loans' && (+this.country === 1 || +this.country === 6)) {
        radioHandler(val, [
          { name: 'other_loans_amount' }
        ])
      }
      if (this.history[this.currentStep].name === 'has_car' && +this.country === 1) {
        radioHandler(val, [
          { name: 'plate_number' }
        ])
      }
      if (this.history[this.currentStep].name === 'has_other_loans' && +this.country === 2) {
        radioHandler(val, [
          { name: 'other_loans_amount' },
          { name: 'other_loans_company', skipValue: 'Other' }
        ])
      }
      if (this.history[this.currentStep].name === 'has_bank_online' && +this.country === 2) {
        radioHandler(val, [
          { name: 'bank_account_number', skipValue: 'IGNORE', deleteOnYes: true }
        ])
      }
      if (this.history[this.currentStep].name === 'reference_exist' && +this.country === 2) {
        radioHandler(val, [
          { name: 'reference_name', deleteOnNo: true },
          { name: 'reference_surname', deleteOnNo: true },
          { name: 'reference_phone', deleteOnNo: true }
        ])
      }

      this.$store.dispatch('nextStepPrepare', +1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/inputs";
</style>



// WEBPACK FOOTER //
// src/components/fields/Radio.vue